import { toast } from 'sonner';
import i18next from 'i18next';
import { useTenantStore } from '@/store/tenant.store.js';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class NotificationTemplateIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async list(params = {}) {
        if (!useTenantStore.getState().selectedTenantId) return { success: false, data: [] };
        try {
            return await this.service.getAll(params);
        } catch (error) {
            return { success: false, data: [], error: getIntegrationErrorMessage(error) };
        }
    }

    async create(data) {
        try {
            const result = await this.service.create(data);
            toast.success(i18next.t('notificationTemplate:messages.created', { defaultValue: 'Notification template created' }));
            return result;
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async update(id, data) {
        try {
            const result = await this.service.update(id, data);
            toast.success(i18next.t('notificationTemplate:messages.updated', { defaultValue: 'Notification template updated' }));
            return result;
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async delete(id) {
        try {
            const result = await this.service.delete(id);
            toast.success(i18next.t('notificationTemplate:messages.deleted', { defaultValue: 'Notification template deleted' }));
            return result;
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async getVariableContract(params = {}) {
        if (!useTenantStore.getState().selectedTenantId) return { success: false, data: null };
        try {
            return await this.service.getVariableContract(params);
        } catch (error) {
            return { success: false, data: null, error: getIntegrationErrorMessage(error) };
        }
    }

    async preview(payload) {
        if (!useTenantStore.getState().selectedTenantId) return { success: false, data: null };
        try {
            return await this.service.preview(payload);
        } catch (error) {
            return { success: false, error: getIntegrationErrorMessage(error) };
        }
    }

    async testSend(payload) {
        try {
            const result = await this.service.testSend(payload);
            toast.success(i18next.t('notificationTemplate:messages.testSent', {
                defaultValue: 'Test notification queued for your account',
            }));
            return result;
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }
}
